import { Component, Input, OnInit } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';

@Component({
  selector: 'app-audit-detail',
  templateUrl: './audit-detail.page.html',
  styleUrls: ['./audit-detail.page.scss'],
})
export class AuditDetailPage implements OnInit {
  @Input('activeAuditDetail') activeAuditDetail: any = {};

  constructor(
    private modalController: ModalController,
    private toastController: ToastController
  ) { }

  dadosParaExibir: any = null;

  ngOnInit() {
    if (this.activeAuditDetail?.dadosExtras) {
      // Tenta garantir que o dado seja um Objeto/Array e não uma string.
      // Se a API mandar string, fazemos o parse. Se já for objeto, mantemos.
      try {
        this.dadosParaExibir = typeof this.activeAuditDetail.dadosExtras === 'string' 
          ? JSON.parse(this.activeAuditDetail.dadosExtras) 
          : this.activeAuditDetail.dadosExtras;
      } catch (error) {
        console.error('Erro ao fazer parse dos dadosExtras:', error);
        this.dadosParaExibir = this.activeAuditDetail.dadosExtras;
      }
    } else {
      this.dadosParaExibir = null;
    }
  }

  closeModal(data?: any) {
    this.modalController.dismiss(data);
  }

  isObject(valor: any): boolean {
    return typeof valor === 'object' && valor !== null;
  }

  formatarChave(chave: any): string {
    // Transforma "NumContrato" em "Num Contrato" para ficar mais bonito
    return String(chave).replace(/([A-Z])/g, ' $1').trim();
  }

  // TODO ANDRE: Este fix existe porque a padronizacao dos logs no backend esta falha,
  // ou porque a logica de exibicao no cliente nao e a ideal. Hoje o title precisa
  // ser mapeado por pelo menos 3 chaves diferentes: acao, desModulo e w_desc.
  obterTituloAuditoria(): string {
    const acoesComTitulo = [
      'Ler Promoção',
      'Ler Notificação',
      'Ler Comunicado',
      'Ler Solicitação',
      'Aceitar Aviso',
      'Aceitar Notificação',
      'Aceitar Solicitação',
      'Aceitar Prestações de contas',
      'Aceitar Comunicado',
      'Aceitar Promoção',
    ];

    if (acoesComTitulo.includes(this.activeAuditDetail?.acao)) {
      return this.activeAuditDetail.acao;
    }

    return this.activeAuditDetail?.desModulo || this.activeAuditDetail?.w_desc || 'Não informado';
  }

  // TODO ANDRE: Este fix existe porque o campo titulo do payload por vezes
  // esta vindo null no detalhe da lista de auditoria. Nesses casos, foi
  // necessario criar um fallback local baseado na acao para preencher o titulo.
  obterTituloListaAuditoria(): string {
    const titulo = this.activeAuditDetail?.titulo;

    if (typeof titulo === 'string' && titulo.trim()) {
      return titulo;
    }

    const acoesComTituloLista = [
      'Ler Promoção',
      'Ler Notificação',
      'Ler Comunicado',
      'Ler Solicitação',
      'Aceitar Aviso',
      'Aceitar Notificação',
      'Aceitar Solicitação',
      'Aceitar Prestações de contas',
      'Aceitar Comunicado',
      'Aceitar Promoção',
      'Aceitar Venda Não Informada',
    ];

    if (acoesComTituloLista.includes(this.activeAuditDetail?.acao)) {
      return this.activeAuditDetail.acao;
    }

    return 'Não informado';
  }

  removerKeysEValues(dados: any): any {
    if (Array.isArray(dados)) {
      // Se identificar que é a estrutura de Dicionário do C# (tem propriedade key e value)
      if (dados.length > 0 && 'key' in dados[0] && 'value' in dados[0]) {
        const objetoFormatado: any = {};
        dados.forEach(item => {
          // Coloca o valor dentro da propriedade identificada no item.key
          objetoFormatado[item.key] = this.removerKeysEValues(item.value);
        });
        return objetoFormatado;
      }
      // Se for um Array normal de objetos, apenas continua a limpeza nos filhos
      return dados.map(item => this.removerKeysEValues(item));
    } 
    else if (typeof dados === 'object' && dados !== null) {
      const objetoFormatado: any = {};
      for (const chave in dados) {
        objetoFormatado[chave] = this.removerKeysEValues(dados[chave]);
      }
      return objetoFormatado;
    }
    
    return dados; // Retorna o valor direto se for string/numero/etc
  }

  async copiarDadosExtras() {
    // Transforma o objeto limpo em uma string JSON formatada (bonita e indentada)
    const textoParaCopiar = JSON.stringify(this.dadosParaExibir, null, 2);

    try {
      // Tenta copiar para a área de transferência do dispositivo
      await navigator.clipboard.writeText(textoParaCopiar);
      this.exibirToast('Dados copiados com sucesso!', 'success');
    } catch (err) {
      console.error('Falha ao copiar:', err);
      // Fallback caso o navegador bloqueie a cópia
      this.exibirToast('Não foi possível copiar os dados.', 'danger');
    }
  }

  async exibirToast(mensagem: string, cor: string) {
    const toast = await this.toastController.create({
      message: mensagem,
      duration: 2000, // Fica na tela por 2 segundos
      position: 'bottom',
      color: cor
    });
    toast.present();
  }

  isNumero(valor: any): boolean {
    return !isNaN(parseFloat(valor)) && isFinite(valor);
  }
}
